// @flow

import * as React from "react";
import { type ImageType, type LinkType } from "../../types";
import Image from "../atoms/Image";
import TextButton from "../atoms/TextButton";
import Icon from "../atoms/Icon";
import LinkHandler from "../atoms/LinkHandler";

type PropsType = {
    title: string,
    links: {
        icon: ImageType,
        link: LinkType,
    }[],
    eyebrow_cta: LinkType,
};

const IconCtaLinks = (props: PropsType): React.Node => {
    return (
        <div className="icon-cta-links">
            <div className="container-fluid">
                <div className="icon-cta-links__inner">
                    <div className="row">
                        <div className="col-xs-12">
                            <div className="icon-cta-links__header">
                                <h2 className="icon-cta-links__title">
                                    {props.title}
                                </h2>
                                <TextButton
                                    to={props.eyebrow_cta.url}
                                    className="tile-slider__header__events"
                                >
                                    {props.eyebrow_cta.title}
                                </TextButton>
                            </div>
                        </div>
                    </div>
                    <div className="icon-cta-links__list row">
                        {props.links.map(item => {
                            return (
                                <div
                                    key={item.link.title}
                                    className="col-xs-12 col-sm-4"
                                >
                                    <LinkHandler
                                        className="icon-cta-links__item"
                                        to={item.link.url}
                                    >
                                        <span className="icon-cta-links__item__inner">
                                            <div className="icon-cta-links__item__icon">
                                                <Image
                                                    image={item.icon}
                                                    size={"medium"}
                                                    alt="Icon"
                                                    aspectRatio="1:1"
                                                />
                                            </div>
                                            <div className="icon-cta-links__item__title">
                                                {item.link.title}
                                            </div>
                                        </span>
                                        <Icon
                                            className="icon-cta-links__item__arrow"
                                            name="arrow-right"
                                        />
                                    </LinkHandler>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default IconCtaLinks;
